const setErrorDataArray = (data: { val1: string[]; val2: string[] }) => {
	return Object.entries(data).map(el => {
		return { parameter: el[0], message: el[1][0] };
	});
};

export default setErrorDataArray;
